module.exports = __webpack_public_path__ + "img/people_info_512_red.62d09666.png";